import React, { useState, useEffect } from 'react'

import { ViewMode, DrawPolygonMode, DrawPointMode, DrawLineStringMode, ModifyMode } from '@nebula.gl/edit-modes'

import AWS from 'aws-sdk'

import Grow from '@material-ui/core/Grow'
import Tooltip from '@material-ui/core/Tooltip'

import PointIcon from '../../../assets/coordinates.png'
import LineIcon from '../../../assets/line.png'
import PolygonIcon from '../../../assets/shape.png'

import './drawingTools.css'

function DrawingMenu(props) {
  const [tools, setTools] = useState([
    { img: PointIcon, label: 'Point', state: false },
    { img: LineIcon, label: 'Line', state: false },
    { img: PolygonIcon, label: 'Polygon', state: false },
  ])

  useEffect(() => {
    if (!props.draw) {
      props.setMode(() => ViewMode)
      props.setCrossPointer(false)
      setTools([
        { img: PointIcon, label: 'Point', state: false },
        { img: LineIcon, label: 'Line', state: false },
        { img: PolygonIcon, label: 'Polygon', state: false },
      ])
    }
  }, [props.draw])

  const handleClick = (key, state) => {
    const menu = tools
    if (key === 'Point') {
      !state ? props.setMode(() => DrawPointMode) : props.setMode(() => ViewMode)
      menu.map((val) => (val.label === key ? (!state ? (val.state = true) : (val.state = false)) : (val.state = false)))
    }
    if (key === 'Line') {
      !state ? props.setMode(() => DrawLineStringMode) : props.setMode(() => ViewMode)
      menu.map((val) => (val.label === key ? (!state ? (val.state = true) : (val.state = false)) : (val.state = false)))
    }
    if (key === 'Polygon') {
      !state ? props.setMode(() => DrawPolygonMode) : props.setMode(() => ViewMode)
      menu.map((val) => (val.label === key ? (!state ? (val.state = true) : (val.state = false)) : (val.state = false)))
    }
    !state ? props.setCrossPointer(true) : props.setCrossPointer(false)
    setTools(menu)
    props.setSelectedGeometry()
  }

  return (
    <Grow in={props.draw}>
      <div className="dt-sidebar">
        {tools.map((obj) => (
          <Tooltip title={obj.label} placement="right" arrow>
            <button
              id={obj.label}
              className="dt-sidebar-btn"
              style={obj.state ? { background: '#01579b' } : null}
              onClick={() => handleClick(obj.label, obj.state)}
            >
              <img src={obj.img} className="dt-sidebar-icons" />
            </button>
          </Tooltip>
        ))}
      </div>
    </Grow>
  )
}

export default DrawingMenu
